import techSHE from "../assets/img/logos/logo-TechSHEssions-compact.png"
import adalab from "../assets/img/logos/adalab.png"
import step from "../assets/img/logos/step.png"
import les from "../assets/img/logos/les.png"
import freak from "../assets/img/logos/freak.png"
import gals from "../assets/img/logos/itgals.jpg"
import disco from "../assets/img/logos/disco.jpg"
import tele from "../assets/img/logos/TeleMadrid.svg.png"
import op from "../assets/img/logos/opground.jfif"
import a11y from "../assets/img/logos/a11y.png";
import codemotion from "../assets/img//logos/codemotion.png";
import commit from "../assets/img/logos/commit.png";
import sirviendo from "../assets/img/logos/sirviendo.svg";
import wtm from "../assets/img/logos/wtmambassador.png";

export const collaborationsArray = [
    {
        alt:"a11yConf",
        imageSrc: a11y,
        imageHref: "https://a11yconf.com/es",
        title: "collaborations.a11yOne",
        year: "collaborations.a11yTwo",
        description: "collaborations.a11yThree",
    },
    {
        alt:"Step4ward",
        imageSrc: step,
        imageHref: "https://step4ward.es/",
        title: "collaborations.stepOne",
        year: "collaborations.stepTwo",
        description: "collaborations.stepThree",
    },
    {
        alt:"wtm",
        imageSrc: wtm,
        imageHref: "https://www.technovation.org/women-techmakers",
        title: "collaborations.wtmOne",
        year: "collaborations.wtmTwo",
        description: "collaborations.wtmThree",
    },
    {
        alt:"Sirviendo código",
        imageSrc: sirviendo,
        imageHref: "https://sirviendocodigoawards.com/",
        title: "collaborations.sirviendoOne",
        year: "collaborations.sirviendoTwo",
        description: "collaborations.sirviendoThree",
    },
        {
        alt:"Sirviendo código",
        imageSrc: sirviendo,
        imageHref: "https://sirviendocodigoawards.com/",
        title: "collaborations.sirviendoAwardOne",
        year: "collaborations.sirviendoAwardTwo",
        description: "collaborations.sirviendoAwardThree",
    },
    {
        alt:"CommitConf",
        imageSrc: commit,
        imageHref: "https://commit-conf.com/",
        title: "collaborations.commitOne",
        year: "collaborations.commitTwo",
        description: "collaborations.commitThree",
        hasBackground: true
    },
    {
        alt:"Codemotion",
        imageSrc: codemotion,
        imageHref: "https://conferences.codemotion.com/",
        title: "collaborations.codemotionOne",
        year: "collaborations.codemotionTwo",
        description: "collaborations.codemotionThree",
    },
]

export const mentorArray = [
        {
        alt:"TechSHEssions",
        imageSrc: techSHE,
        imageHref: "https://techshessions.com/",
        title: "collaborations.techMOne",
        year: "collaborations.techMTwo",
        description: "collaborations.techMThree",
    },
    {
        alt:"TechSHEssions",
        imageSrc: techSHE,
        imageHref: "https://techshessions.com/",
        title: "collaborations.techOne",
        year: "collaborations.techTwo",
        description: "collaborations.techThree",
    },
    {
        alt:"Adalab",
        imageSrc: adalab,
        imageHref: "https://adalab.es/",
        title: "collaborations.adalabOne",
        year: "collaborations.adalabTwo",
        description: "collaborations.adalabThree",
    },
]

export const volunteerArray = [

    {
        alt:"Ludo Ergo Sum",
        imageSrc: les,
        imageHref: "https://www.ludoergosum.org/",
        title: "collaborations.lesOne",
        year: "collaborations.lesTwo",
        description: "collaborations.lesThree",
    },
    {
        alt:"Freak Wars",
        imageSrc: freak,
        imageHref: "https://freakwarsmadrid.com/",
        title: "collaborations.freakOne",
        year: "collaborations.freakTwo",
        description: "collaborations.freakThree",
    },
]

export const interviewArray = [
    {
        alt:"Disco duro de roer",
        imageSrc: disco,
        imageHref: "https://www.youtube.com/watch?v=oG3iu4LgzeY&t=4113s",
        title: "collaborations.discoOne",
        year: "collaborations.discoTwo",
        description: "collaborations.discoThree",
    },
    {
        alt:"IT Gals",
        imageSrc: gals,
        imageHref: "https://www.youtube.com/watch?v=I2jBvdtMNmE&ab_channel=ITgals",
        title: "collaborations.itOne",
        year: "collaborations.itTwo",
        description: "collaborations.itThree",
    },
    {
        alt:"TeleMadrid",
        imageSrc: tele,
        imageHref: "https://www.telemadrid.es/programas/nos-vemos-en-el-bar/Nos-vemos-en-el-bar-Bares-divertidos-2-2607959198--20231021103000.html",
        title: "collaborations.teleOne",
        year: "collaborations.teleTwo",
        description: "collaborations.teleThree",
    },
        {
        alt:"Opground",
        imageSrc: op,
        imageHref: "https://www.youtube.com/watch?v=3S9at2lYPjA",
        title: "collaborations.opOne",
        year: "collaborations.opTwo",
        description: "collaborations.opThree",
    },
    {
        alt:"IT Gals",
        imageSrc: gals,
        imageHref: "https://www.youtube.com/watch?v=ljT-Zwobxos&feature=emb_title&ab_channel=ITgals",
        title: "collaborations.itOne",
        year: "collaborations.itGalsTwo",
        description: "collaborations.itGalsThree",
    },
]